class IrTop {
  constructor() {
    const swiperEl = document.querySelector('.js-ir-news-swiper');
    if(swiperEl){
      this.loadedSwiper(swiperEl);
      this.toggleSwiper(swiperEl);
    }
  }

  initSwiper(item) {
    new Swiper(item, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      navigation: {
        prevEl: item.querySelector('.js-ir-news-swiper__prev'),
        nextEl: item.querySelector('.js-ir-news-swiper__next'),
      }
    });
    item.style.opacity = 1;
  }

  loadedSwiper(swiperEl){
    const mm = gsap.matchMedia();
    this.onAdded('.js-ir-news-swiper .swiper-slide',()=>{
      mm.add('(max-width: 769px)', () => {
        this.initSwiper(swiperEl);
      });
    })
  }

  toggleSwiper(swiperEl){
    this.onAdded('.js-ir-news-swiper .swiper-slide',()=>{
      const buttonEls = document.querySelectorAll('.c-tab-list__button');
      buttonEls.forEach(button => {
        button.addEventListener('click',()=>{
          swiperEl.style.opacity = 0;
          setTimeout(()=>{
            this.initSwiper(swiperEl);
          },200)
        })
      })
    })
  }

  onAdded(selector, cb) {
    const found = document.querySelector(selector);
    if (found) return cb(found); 

    const mo = new MutationObserver((mutations, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        cb(el);
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
}

class Recruit {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // スロットリング関数
    function throttle(callback, delay) {
      let last;
      let timer;
      return function () {
        const now = Date.now();
        if (last && now < last + delay) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            last = now;
            callback();
          }, delay);
        } else {
          last = now;
          callback();
        }
      };
    }

    // スクロールイベントの処理
    function handleScroll() {
      const $mv = $('.js-mv');
      const $fixedBtn = $('.js-fixedBtn');
      const $bottom = $('.js-bottom');
      
      if ($mv.length === 0 || $fixedBtn.length === 0 || $bottom.length === 0) return;

      const mvBottom = $mv.offset().top + $mv.outerHeight();
      const viewportTop = $(window).scrollTop();
      const bottomTop = $bottom.offset().top;
      const viewportBottom = viewportTop + $(window).height();

      // .js-mv が完全に見えなくなり、.js-bottom が見えていないときに .is-active を追加
      if (mvBottom < viewportTop && bottomTop > viewportBottom) {
        $fixedBtn.addClass('is-active');
      } else {
        $fixedBtn.removeClass('is-active');
      }
    }

    // スロットリングを適用してイベントリスナーを追加
    $(window).on('scroll', throttle(handleScroll, 100));

  }
}

class RecruitForm {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $('[name=requirements-select] option').each(function() {
      if($(this).text() == '—Please choose an option—') {
        $(this).text('選択してください');
      }

      let url = new URL(window.location.href);
      let params = url.searchParams;
      
      if(params.get('id') == $(this).text()) {
        $(this).prop('selected', true);
      }
    })

    setTimeout(() => {
      $('.cd-upload-btn').off();
    }, 500);

    $('.wpcf7-submit').click(function() {
      const date = new Date();
      const formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      const formattedTime = `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;

      $('.js-time').val(`${formattedDate} ${formattedTime}`);
    })
  }
}

class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {

    gsap.utils.toArray(".js-img-parallax").forEach((img) => {
      gsap.to(img, {
        y: (i, target) => target.clientHeight * -0.2, // パララックスの効果量を調整（-0.2など）
        ease: "none",
        scrollTrigger: {
          trigger: img,
          start: "top bottom", // 表示領域に入るタイミング
          end: "bottom top",   // 表示終了領域を設定
          scrub: 1,         // スクロールに応じてアニメーションが同期
        },
      });
    });

    // カウントアップの関数
    function countUp(element) {
      const target = $(element);
      const countTo = parseFloat(target.data('count')); // data-countの値を取得
      let startVal = countTo % 1 === 0 ? 1 : 0.1; // 小数点があれば0.1から開始、なければ1から開始
      const increment = startVal;

      $({ countNum: startVal }).animate(
        { countNum: countTo },
        {
          duration: 1333, // カウントアップの時間を2/3に設定
          easing: 'swing',
          step: function () {
            target.text(this.countNum.toFixed(countTo % 1 === 0 ? 0 : 1));
          },
          complete: function () {
            target.text(countTo.toFixed(countTo % 1 === 0 ? 0 : 1));
          },
        }
      );
    }

    // 表示領域に入ったときにカウントアップする処理
    $(window).on('scroll', function () {
      $('.js-countup').each(function () {
        const elemPos = $(this).offset().top;
        const scroll = $(window).scrollTop();
        const windowHeight = $(window).height();

        if (scroll > elemPos - windowHeight && !$(this).hasClass('counted')) {
          $(this).addClass('counted'); // 重複カウントを防止
          countUp(this); // カウントアップの実行
        }
      });
    });

    // Swiperのインスタンスを宣言するための変数
    let parallaxSlider;

    // Swiperが使用する要素が存在するか確認
    if ($('.image-slider').length > 0) {
      parallaxSlider = new Swiper('.image-slider', {
        loop: true,
        effect: 'fade',
        allowTouchMove: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 2000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      });
    }

    // parallaxSliderのインスタンスが存在する場合のみ自動再生を停止
    if (parallaxSlider) {
      parallaxSlider.autoplay.stop();
    }

    var tl = gsap.timeline();

    tl.to(".js-h1 div span", .8, {
      y: 0,
      stagger: 0.2,
    }, '0.5');
    tl.to(".js-img", 1, {
      y: 0,
      opacity: 1,
      force3D: true,
    }, '-=0.5');
    tl.to(".js-slider", 1, {
      y: 0,
      opacity: 1,
      force3D: true,
    }, '-=0.5');
    tl.to(".js-mascot", 0.5, {
      x: 0,
      opacity: 1,
    }, '+=0.5');
    tl.to(".js-header", 1, {
      opacity: 1,
      force3D: true,
      onComplete: () => {
        if (parallaxSlider) {
          parallaxSlider.autoplay.start();
        }
      },
    }, '<');

    let companySlider = {
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1500,
    };

    $('.company-slider').each(function(index) {
      new Swiper(`.company-slider${index + 1}`, companySlider);
    });

    let irSwiper;
    irSwiper = new Swiper('.irSwiper', {
      spaceBetween: 20,
      slidesPerView: 1.2,
      speed: 500,
      breakpoints: {
        // スライドの表示枚数：767px以上の場合
        767: {
          spaceBetween: 30,
          slidesPerView: 3.6,
        }
      },
      navigation: {
        nextEl: ".irSwiper-prev",
        prevEl: ".irSwiper-next",
      },
    });

    // JSONデータを取得し、スライドを生成する関数
    async function fetchDataAndCreateSlides() {
      try {
        // URLからJSONデータをフェッチ
        const response = await fetch('https://science-arts.com/buddycomNewsJson.php');
        
        // JSONデータをパース
        const jsonData = await response.json();
        
        // スライドを挿入する要素を取得
        const container = await document.querySelector('#news');

        // JSONデータから8件を取得してスライドを作成
        await jsonData.slice(0, 8).forEach((item) => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide');

          const anchor = document.createElement('a');
          anchor.href = item.link;
          anchor.target = '_blank';

          const dl = document.createElement('dl');

          const dt = document.createElement('dt');
          const date = document.createElement('span');
          date.classList.add('date');
          date.textContent = item.date; // 日付を適宜変更

          const label = document.createElement('span');
          label.classList.add('label', 'label-info');
          label.textContent = 'News release';

          dt.appendChild(date);
          dt.appendChild(label);

          const dd = document.createElement('dd');
          const p = document.createElement('p');
          p.classList.add('ttl');
          p.textContent = item.title;

          dd.appendChild(p);

          dl.appendChild(dt);
          dl.appendChild(dd);

          anchor.appendChild(dl);
          slide.appendChild(anchor);
          container.appendChild(slide);
        });

        let newsSwiper;
        newsSwiper = new Swiper('.newsSwiper', {
          spaceBetween: 20,
          slidesPerView: 1.2,
          speed: 500,
          breakpoints: {
            // スライドの表示枚数：767px以上の場合
            767: {
              spaceBetween: 30,
              slidesPerView: 3.6,
            }
          },
          navigation: {
            nextEl: ".irSwiper-prev",
            prevEl: ".irSwiper-next",
          },
        });

      } catch (error) {
        console.error('データの取得に失敗しました', error);
      }
    }

    // ページロード時にデータを取得してスライドを生成
    fetchDataAndCreateSlides();


  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
class AlpineStore {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    // スマホ判別
    Alpine.store('isMobile', window.innerWidth <= 768);

    function checkScreenSize() {
      Alpine.store('isMobile', window.innerWidth <= 768);
    }

    window.addEventListener('resize', checkScreenSize);

  }
}

class Common {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    let scrollTimeout;

    if($('.p-recruit').length) {
      $('html').addClass('is-menu');
    } else {

      // ページロード時にスクロール位置を確認
      if ($(window).scrollTop() > 10) {
        $('html').addClass('is-menu');
      } else {
        $('html').removeClass('is-menu');
      }
      
      $(window).on('scroll', function() {
        clearTimeout(scrollTimeout);
  
        scrollTimeout = setTimeout(function() {
          if ($(window).scrollTop() > 10) {
            $('html').addClass('is-menu');
          } else {
            $('html').removeClass('is-menu');
          }
        }, 100);
      });
    }

    $('.js-drawer').on('click touchstart', function() {
      $('html').toggleClass('is-drawer');
    });


    
    
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })


    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= '769') {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-transition');
          setTimeout(() => {
            item.classList.add('is-inview');
          }, 300);
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-transition');
          setTimeout(() => {
            item.classList.add('is-inview');
          }, 300);
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
      e.style.opacity = 0;
      e.style.transform = 'translateY(30px)';
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}


class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).on('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBan();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBan();
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class SiteNav {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let targets = document.querySelectorAll('[id*=anchor]');

    targets.forEach(function(el) {

      gsap.to(el, { // .box => アニメーションさせる要素
        scrollTrigger: {
          trigger: el, // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
          start: 'top center', // アニメーションの開始位置の指定
          end: 'bottom center', // アニメーションの開始位置の指定
          onEnter: (el) => {
            let elId = el.trigger.getAttribute('id');
            $(`[href*=${elId}`).siblings().removeClass('is-active');
            $(`[href*=${elId}`).addClass('is-active');
          },
          onLeaveBack: (el) => {
            let elId = el.trigger.getAttribute('id');
            $(`[href*=${elId}`).prev().siblings().removeClass('is-active');
            $(`[href*=${elId}`).prev().addClass('is-active');
          }
        }
      });
    })
  }
}

class Smoothscroll {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $('a[href^="#"]').click(function(){
      var adjust = 0;
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top + adjust;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
  }
}

(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let top = new Top('p-top');
  let recruit = new Recruit('p-recruit');
  let common = new Common();
  let contact = new RecruitForm('p-contact');
  let smoothscroll = new Smoothscroll();

  // ページ単位
  new IrTop();
  
  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let modal = new Modal('js-modal');
  let siteNav = new SiteNav('js-siteNav');
  let accordion = new Accordion('js-accordion');
  let editor = new Editor('c-content');
});

  
// ------------------------------
// ローディング用
// ------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const progressBar = document.querySelector('.progress-bar');

  // ページの読み込みが始まったら少し進めておく
  progressBar.style.width = '20%';

  // ページ読み込みの進捗をシミュレートする
  const interval = setInterval(() => {
    const currentWidth = parseFloat(progressBar.style.width);
    if (currentWidth < 90) {
      progressBar.style.width = (currentWidth + 1) + '%';
    }
  }, 100);

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener('load', () => {
    progressBar.style.width = '100%';
    clearInterval(interval);
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, 500);
  });
});

document.addEventListener('alpine:init', () => {
  new AlpineStore();
})